import { ApolloError, useMutation } from "@apollo/client";
import { useAuth } from "@src/common/hooks/useAuth";
import { useErrorToast } from "@src/common/hooks/useErrorToast";
import { useCourieStore } from "@src/common/lib/store";
import { ASSIGN_BILLABLE_ITEM_TO_ORDER } from "../graphql/orderBillableItem";

export function useAssignBillableItemToOrder() {
  const { courierId } = useAuth();
  const showError = useErrorToast();
  const { showToast } = useCourieStore();
  const [mutate, { loading }] = useMutation(ASSIGN_BILLABLE_ITEM_TO_ORDER);

  function assignBillableItemToOrder(
    orderId: string,
    billableItemId: string | null
  ): Promise<void> {
    if (!courierId) return Promise.reject(new Error("No courier ID available"));
    return mutate({ variables: { courierId, orderId, billableItemId } })
      .then(() => {
        showToast({
          message: billableItemId
            ? "Billable item assigned"
            : "Billable item removed",
          type: "success",
        });
      })
      .catch((error) => {
        showError(error as ApolloError);
        throw error;
      });
  }

  return { assignBillableItemToOrder, isAssigning: loading };
}
